import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  /* ─────────── Gallery items — fill in each `link` value ─────────── */
  const galleryItems = [
    { src: '/SF WEB IMAGES/hgg5.jpeg',    link: 'https://music.apple.com/us/album/hgg5-basement-jazz/1824013885' },
    { src: '/SF WEB IMAGES/hgg2.jpg',    link: 'https://music.apple.com/us/album/hgg2/1691183867' },
    { src: '/SF WEB IMAGES/stout.jpeg',    link: 'https://music.apple.com/us/album/18159-stout/1656759672' },
    { src: '/SF WEB IMAGES/gun.jpg',    link: 'https://music.apple.com/us/album/he-got-a-gun/1623469023' },
    { src: '/SF WEB IMAGES/peter.jpg',    link: 'https://music.apple.com/us/album/peter/1585512769' },
    { src: '/SF WEB IMAGES/rufus.jpg',    link: 'https://music.apple.com/us/album/rufus/1490439470' },
    { src: '/SF WEB IMAGES/andrews.jpg',    link: 'https://music.apple.com/us/album/friday-night-at-st-andrews/1435749500' },
    { src: '/SF WEB IMAGES/cheese.jpg',    link: 'https://music.apple.com/us/album/blue-cheese-coney-island/1770130945' },
    { src: '/SF WEB IMAGES/circus.jpg',    link: 'https://music.apple.com/us/album/hannicap-circus/1435666939' },
    { src: '/SF WEB IMAGES/weirdos.jpg',    link: 'https://music.apple.com/us/album/attack-of-the-weirdos/65508375' },
  ];

  return (
    <>
      <style>{`
@font-face {
  font-family: 'CustomFont';
  src: url('/Orbitron/Orbitron-VariableFont_wght.ttf') format('woff2'),
       url('/Orbitron/Orbitron-VariableFont_wght.ttf') format('woff');
  font-weight: normal;
  font-style: normal;
}

body {
  font-family: 'CustomFont', sans-serif;
  margin: 0;
  padding: 0;
  background-color: #000;
  color: #fff;
}

header {
  background-color: #000;
  color: #fff;
  padding-top: 20px;
  padding-bottom: 20px;
  text-align: center;
  position: relative;      /* add this line */
}
  .buy-coffee {
  position: absolute;
  top: 20px;            /* lines up with header padding */
  right: 20px;
  color: #f5c65d;
  text-decoration: none;
  line-height: 1.1;
    font-size: 0.93rem;
  text-align: center;
  font-family: 'CustomFont', sans-serif;
}


nav {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

nav a {
  color: #fff;
  text-decoration: none;
}

nav a:active {
  color: #f5c65d;
}

/* Social links spacing and centering */
.social-links {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 15px;
  
}

.social-links a {
  color: #fdca05;
  text-decoration: none;
}

.header-logo {
  width: 250px;
  height: auto;
  /* Change the width above to resize the logo */
}

footer {
  background-color: #000;
  color: #fff;
  text-align: center;
  padding: 0px 0;
  position: fixed;
  font-size: 0.73rem;
  bottom: 0;
  width: 100%;
}

@media screen and (max-width:600px){
  nav {
    flex-wrap: wrap;
    gap: 10px;
  }
}

.gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
}

.gallery img {
  width: 100%;
  height: auto;
}

@media screen and (max-width:600px){
  .gallery {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 5px;
  }
}
`}</style>



      <main>
        <section className="gallery">
          {galleryItems.map(({ src, link }, idx) =>
            link ? (
              <a
                key={idx}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={src} alt="Gallery item" />
              </a>
            ) : (
              <img key={idx} src={src} alt="Gallery item" />
            )
          )}
        </section>
      </main>

      <footer>
        <p>&copy; 2025 Street Flavor Records / SPNDAT INC. All rights reserved.</p>
      </footer>
    </>
  );
};

export default Home;
